import { createFileRoute, redirect } from '@tanstack/react-router';

import { ProfilePage } from '@/pages/profile';

export const Route = createFileRoute('/_user/profile')({
  beforeLoad: async ({ context }) => {
    const user =
      context.auth.user ?? (await context.auth.userRefetch().catch(() => null));

    if (!user) {
      throw redirect({ to: '/sign-in' });
    }
  },
  component: ProfilePage,
});
